export interface Picture {
  id: number;
  url: string;
}

export interface PictureWithoutId {
  url: string;
}

export const allowedMimeTypes = ['image/png', 'image/jpeg', 'image/gif'];

export const allowedMimeBase64Start = allowedMimeTypes.map(
  mime => `data:${mime};base64,`
);
